var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.uploadShow)?_c('UploadAbstract',{on:{"upload-result":_vm.generatorRes}}):_c('div',[_c('ToolRight')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }